import { HttpClientModule, HttpClient } from '@angular/common/http';
import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewChild, Input, Output, ChangeDetectionStrategy, ContentChild, Pipe, Directive, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as i8 from '@ngx-translate/core';
import { TranslateService, TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { isNull } from 'common-utils/dist/typescript-utils';
import { debounceTime } from 'rxjs/operators';
import * as i1$1 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i2 from '@angular/platform-browser';
import * as i5 from '@angular/cdk/scrolling';
import { ScrollingModule } from '@angular/cdk/scrolling';
import * as i6 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i3 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

class TreeNodeComponent {
    constructor() {
        this._model = {
            children: [],
            disabled: false,
            expanded: false,
            highlighted: false,
            id: '',
            selected: false,
            shown: false,
            placeholder: false
        };
        this._multiSelect = false;
        this._forceSelection = false;
        this._hideDisabledCheckbox = false;
        this._expandable = true;
        this._checkbox = false;
        this._labelIdentifier = 'displayLabel';
        this._typeIdentifier = 'nodeType';
        this._iconIdentifier = 'nodeType';
        this.DEFAULT_ICON_DEFINITION = {
            [this._iconIdentifier]: 'spaces',
        };
        this._iconDefinitions = this.DEFAULT_ICON_DEFINITION;
        this.selection$ = new EventEmitter();
        this.deselection$ = new EventEmitter();
        this.clicked$ = new EventEmitter();
        this.expansion$ = new EventEmitter();
    }
    set model(newModel) {
        this._model = newModel;
    }
    ;
    get model() {
        return this._model;
    }
    set multiSelect(multiSelect) {
        this._multiSelect = multiSelect;
    }
    get multiSelect() {
        return this._multiSelect;
    }
    set forceSelection(forceSelection) {
        this._forceSelection = forceSelection;
    }
    get forceSelection() {
        return this._forceSelection;
    }
    set hideDisabledCheckbox(hide) {
        this._hideDisabledCheckbox = hide;
    }
    get hideDisabledCheckbox() {
        return this._hideDisabledCheckbox;
    }
    set checkbox(checkbox) {
        this._checkbox = checkbox;
    }
    get checkbox() {
        return this._checkbox;
    }
    set expandable(expandable) {
        this._expandable = expandable;
    }
    get expandable() {
        return this._expandable;
    }
    get hasChildren() {
        return this._model.children !== undefined && this._model.children.length > 0;
    }
    set labelIdentifier(labelIdentifier) {
        if (isNull(labelIdentifier))
            return;
        this._labelIdentifier = labelIdentifier;
    }
    get labelIdentifier() {
        return this._labelIdentifier;
    }
    set typeIdentifier(typeIdentifier) {
        if (isNull(typeIdentifier))
            return;
        this._typeIdentifier = typeIdentifier;
    }
    get typeIdentifier() {
        return this._typeIdentifier;
    }
    set iconIdentifier(iconIdentifier) {
        if (isNull(iconIdentifier))
            return;
        this._iconIdentifier = iconIdentifier;
    }
    get iconIdentifier() {
        return this._iconIdentifier;
    }
    checkNode($event) {
        $event.preventDefault();
        $event.stopImmediatePropagation();
        $event.stopPropagation();
        if (this.elementRef) {
            this.elementRef.checked = this._model.selected;
        }
        if (!this._model.disabled && !this._model.placeholder) {
            if (this._model.selected) {
                this.deselection$.emit(this._model);
            }
            else {
                this.selection$.emit(this._model);
            }
        }
        this.clicked$.emit(this._model);
    }
    expandNode() {
        this.expansion$.emit(this._model);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TreeNodeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: TreeNodeComponent, selector: "tree-node", inputs: { model: "model", multiSelect: "multiSelect", forceSelection: "forceSelection", hideDisabledCheckbox: "hideDisabledCheckbox", checkbox: "checkbox", expandable: "expandable", labelIdentifier: "labelIdentifier", typeIdentifier: "typeIdentifier", iconIdentifier: "iconIdentifier", childTemplate: "childTemplate" }, outputs: { selection$: "selection$", deselection$: "deselection$", clicked$: "clicked$", expansion$: "expansion$" }, viewQueries: [{ propertyName: "elementRef", first: true, predicate: ["checkbox"], descendants: true }], ngImport: i0, template: "<div class=\"w-auto tree-node flex justify-start\" attr.data-automation=\"{{model.id}}\">\r\n  <span *ngIf=\"model.selected\" class=\"tree-node-margin\"></span>\r\n\r\n  <span [style.padding-left]=\"model.parent?.length * 1.25 + 'em'\"></span>\r\n\r\n  <mat-icon *ngIf=\"hasChildren && expandable\" (click)=\"expandNode()\" class='tree-node-chevron'>{{model.expanded ? 'expand_more' : 'chevron_right'}}</mat-icon>\r\n\r\n  <mat-checkbox #checkbox class='x-mat-checkbox' *ngIf=\"!model.placeholder && ((checkbox && !model.disabled) || (checkbox && model.disabled && !hideDisabledCheckbox))\"\r\n                [disabled]=\"model.disabled\"\r\n                [checked]=\"model.selected\"\r\n                (click)=\"checkNode($event)\">\r\n  </mat-checkbox>\r\n\r\n  <span class=\"tree-node-icon\" (click)=\"checkNode($event)\"><mat-icon *ngIf=\"model.icon\" svgIcon=\"{{model.icon}}\"></mat-icon></span>\r\n\r\n  <ng-container *ngIf=\"childTemplate\" [ngTemplateOutlet]=\"childTemplate\"\r\n                [ngTemplateOutletContext]=\"{ $implicit: model }\"></ng-container>\r\n  <ng-container *ngIf=\"!childTemplate\">\r\n    <span [ngClass]=\"{'highlighted':model.highlighted, 'unselectable':(model.disabled && !hideDisabledCheckbox && !model.placeholder)}\" class=\"tree-node-label\" (click)=\"checkNode($event)\">\r\n      {{ model[labelIdentifier] }}\r\n    </span>\r\n  </ng-container>\r\n</div>\r\n", styles: [".enel-tree-invisible{display:none}.tree-node{padding-left:2.25em;margin-top:.25em;margin-bottom:.25em;line-height:1.25em;height:2em;box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-align-content:center;-ms-flex-line-pack:center;align-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}.tree-node ul li{margin-top:0;margin-bottom:0;list-style-type:none}.tree-node mat-checkbox span{display:inline-block}.tree-node mat-checkbox mat-icon svg{stroke:#444;stroke-width:1px;padding:4px}.tree-node:hover{background-color:rgba(70,30,125,.12);position:relative}.tree-node-align{padding-left:24px}.tree-node-icon{margin-top:4px;-webkit-transform:scale(.8);-ms-transform:scale(.8);transform:scale(.8);cursor:pointer}.tree-node-chevron{display:inline-block;margin-left:-24px;margin-right:-2px;-webkit-transform:scale(.8);-ms-transform:scale(.8);transform:scale(.8);cursor:pointer}.highlighted{font-weight:700}.tree-node-margin{position:absolute;background-color:#461e7d;width:4px;height:inherit;left:0}.unselectable{color:#999}mat-checkbox{margin-bottom:1px;-webkit-transform:scale(.9);-ms-transform:scale(.9);transform:scale(.9)}.mat-mdc-checkbox-disabled ::ng-deep span.mat-mdc-checkbox-label mat-icon{color:rgba(0,0,0,.34)}::ng-deep .mat-checkbox-checked.mat-accent .mat-checkbox-background{background-color:var(--primary-color)!important}::ng-deep .mat-checkbox-indeterminate.mat-accent .mat-checkbox-background{border-radius:5px!important;background-color:var(--primary-color)!important}.tree-node-label{display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-height:24px;width:275px;cursor:pointer}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i1$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i3.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TreeNodeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'tree-node', template: "<div class=\"w-auto tree-node flex justify-start\" attr.data-automation=\"{{model.id}}\">\r\n  <span *ngIf=\"model.selected\" class=\"tree-node-margin\"></span>\r\n\r\n  <span [style.padding-left]=\"model.parent?.length * 1.25 + 'em'\"></span>\r\n\r\n  <mat-icon *ngIf=\"hasChildren && expandable\" (click)=\"expandNode()\" class='tree-node-chevron'>{{model.expanded ? 'expand_more' : 'chevron_right'}}</mat-icon>\r\n\r\n  <mat-checkbox #checkbox class='x-mat-checkbox' *ngIf=\"!model.placeholder && ((checkbox && !model.disabled) || (checkbox && model.disabled && !hideDisabledCheckbox))\"\r\n                [disabled]=\"model.disabled\"\r\n                [checked]=\"model.selected\"\r\n                (click)=\"checkNode($event)\">\r\n  </mat-checkbox>\r\n\r\n  <span class=\"tree-node-icon\" (click)=\"checkNode($event)\"><mat-icon *ngIf=\"model.icon\" svgIcon=\"{{model.icon}}\"></mat-icon></span>\r\n\r\n  <ng-container *ngIf=\"childTemplate\" [ngTemplateOutlet]=\"childTemplate\"\r\n                [ngTemplateOutletContext]=\"{ $implicit: model }\"></ng-container>\r\n  <ng-container *ngIf=\"!childTemplate\">\r\n    <span [ngClass]=\"{'highlighted':model.highlighted, 'unselectable':(model.disabled && !hideDisabledCheckbox && !model.placeholder)}\" class=\"tree-node-label\" (click)=\"checkNode($event)\">\r\n      {{ model[labelIdentifier] }}\r\n    </span>\r\n  </ng-container>\r\n</div>\r\n", styles: [".enel-tree-invisible{display:none}.tree-node{padding-left:2.25em;margin-top:.25em;margin-bottom:.25em;line-height:1.25em;height:2em;box-sizing:border-box;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-align-content:center;-ms-flex-line-pack:center;align-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}.tree-node ul li{margin-top:0;margin-bottom:0;list-style-type:none}.tree-node mat-checkbox span{display:inline-block}.tree-node mat-checkbox mat-icon svg{stroke:#444;stroke-width:1px;padding:4px}.tree-node:hover{background-color:rgba(70,30,125,.12);position:relative}.tree-node-align{padding-left:24px}.tree-node-icon{margin-top:4px;-webkit-transform:scale(.8);-ms-transform:scale(.8);transform:scale(.8);cursor:pointer}.tree-node-chevron{display:inline-block;margin-left:-24px;margin-right:-2px;-webkit-transform:scale(.8);-ms-transform:scale(.8);transform:scale(.8);cursor:pointer}.highlighted{font-weight:700}.tree-node-margin{position:absolute;background-color:#461e7d;width:4px;height:inherit;left:0}.unselectable{color:#999}mat-checkbox{margin-bottom:1px;-webkit-transform:scale(.9);-ms-transform:scale(.9);transform:scale(.9)}.mat-mdc-checkbox-disabled ::ng-deep span.mat-mdc-checkbox-label mat-icon{color:rgba(0,0,0,.34)}::ng-deep .mat-checkbox-checked.mat-accent .mat-checkbox-background{background-color:var(--primary-color)!important}::ng-deep .mat-checkbox-indeterminate.mat-accent .mat-checkbox-background{border-radius:5px!important;background-color:var(--primary-color)!important}.tree-node-label{display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-height:24px;width:275px;cursor:pointer}\n"] }]
        }], propDecorators: { elementRef: [{
                type: ViewChild,
                args: ['checkbox']
            }], model: [{
                type: Input
            }], multiSelect: [{
                type: Input
            }], forceSelection: [{
                type: Input
            }], hideDisabledCheckbox: [{
                type: Input
            }], checkbox: [{
                type: Input
            }], expandable: [{
                type: Input
            }], labelIdentifier: [{
                type: Input
            }], typeIdentifier: [{
                type: Input
            }], iconIdentifier: [{
                type: Input
            }], childTemplate: [{
                type: Input
            }], selection$: [{
                type: Output
            }], deselection$: [{
                type: Output
            }], clicked$: [{
                type: Output
            }], expansion$: [{
                type: Output
            }] } });

class TreeComponent {
    constructor(iconRegistry, domSanitizer) {
        this._multiSelect = false;
        this._forceSelection = false;
        this._cascadeSelect = false;
        this._expandable = true;
        this._expandAll = false;
        this._checkbox = false;
        this._showSearch = true;
        this._showControls = true;
        this._allowSelectAllResults = false;
        this._allowDeselectAll = true;
        this._hideIrrelevant = false;
        this._hideDisabledCheckbox = false;
        this._searchString = '';
        this._maxSelections = 0;
        this._labelIdentifier = 'displayLabel';
        this._typeIdentifier = 'nodeType';
        this._iconIdentifier = 'nodeType';
        this._placeholderIdentifier = 'nodeType';
        this._searchPlaceholder = 'Search';
        this._expandedNodes = new Set();
        this._selectedNodes = new Set();
        this._searchFoundNodes = new Set();
        this._nodesToDisplay = new Set();
        this._originalNodes = [];
        this._flattenedTree = [];
        this._virtualTree = [];
        this._mappedTree = {};
        this._loading = true;
        this._searching = false;
        this.DISABLED_NODE_DEFINITION = {
            [this._typeIdentifier]: ['SpaceGroup', 'MeterGroup'],
        };
        this.DEFAULT_ICON_DEFINITION = {
            [this._iconIdentifier]: 'spaces',
        };
        this.DEFAULT_PLACEHOLDER_DEFINITION = {
            [this._placeholderIdentifier]: ['spaces'],
        };
        this.DEFAULT_SEARCH_PROPERTIES = ['displayLabel'];
        this._iconDefinitions = this.DEFAULT_ICON_DEFINITION;
        this._disabledNodeDefinitions = this.DISABLED_NODE_DEFINITION;
        this._searchProperties = this.DEFAULT_SEARCH_PROPERTIES;
        this._placeholderNodeDefinition = this.DEFAULT_PLACEHOLDER_DEFINITION;
        this.tooltipShowDelay = 500;
        this.tooltipHideDelay = 200;
        this.selection$ = new EventEmitter();
        this.deselection$ = new EventEmitter();
        this.expansion$ = new EventEmitter();
        this.clicked$ = new EventEmitter();
        iconRegistry.addSvgIcon('collapse_all', domSanitizer.bypassSecurityTrustResourceUrl('https://cdn.dev-apps.enelx.net/img/icons/collapse_all.svg'));
        iconRegistry.addSvgIcon('select_all', domSanitizer.bypassSecurityTrustResourceUrl('https://cdn.dev-apps.enelx.net/img/icons/select_all.svg'));
        iconRegistry.addSvgIcon('deselect_all', domSanitizer.bypassSecurityTrustResourceUrl('https://cdn.dev-apps.enelx.net/img/icons/deselect_all.svg'));
    }
    set treeData(treeData) {
        if (isNull(treeData))
            return;
        this._originalNodes = JSON.parse(JSON.stringify(treeData));
        if (!this._loading) {
            this.initializeTreeData();
        }
    }
    set multiSelect(multiSelect) {
        this._multiSelect = multiSelect;
        if (!this._multiSelect) {
            this.maxSelections = 1;
            if (this._selectedNodes.size > 1) {
                const firstSelectedNode = this._selectedNodes.values().next().value;
                this.deselectAllNodes();
                this.selectNode(firstSelectedNode);
            }
        }
        else {
            if (this.maxSelections === 1) {
                this.maxSelections = 0;
            }
        }
    }
    get multiSelect() {
        return this._multiSelect;
    }
    set forceSelection(forceSelection) {
        this._forceSelection = forceSelection;
    }
    get forceSelection() {
        return this._forceSelection;
    }
    set checkbox(checkbox) {
        this._checkbox = checkbox;
    }
    get checkbox() {
        return this._checkbox;
    }
    set expandable(expandable) {
        this._expandable = expandable;
    }
    get expandable() {
        return this._expandable;
    }
    set maxSelections(maxSelections) {
        if (isNull(maxSelections)) {
            return;
        }
        // in single select mode, the User can only select one thing
        this._maxSelections = !this._multiSelect ? 1 : maxSelections;
        if (this._multiSelect && this._maxSelections > 0 && this._selectedNodes.size > this._maxSelections) {
            const deselectNodes = [...this._selectedNodes.values()].slice(this._maxSelections, this._selectedNodes.size);
            this.deselectNodes(deselectNodes);
        }
    }
    set labelIdentifier(labelIdentifier) {
        if (isNull(labelIdentifier))
            return;
        this._labelIdentifier = labelIdentifier;
    }
    get labelIdentifier() {
        return this._labelIdentifier;
    }
    set typeIdentifier(typeIdentifier) {
        if (isNull(typeIdentifier))
            return;
        this._typeIdentifier = typeIdentifier;
    }
    get typeIdentifier() {
        return this._typeIdentifier;
    }
    set iconIdentifier(iconIdentifier) {
        if (isNull(iconIdentifier))
            return;
        this._iconIdentifier = iconIdentifier;
    }
    get iconIdentifier() {
        return this._iconIdentifier;
    }
    set iconDefinitions(iconDefinitions) {
        if (isNull(iconDefinitions))
            return;
        this._iconDefinitions = iconDefinitions;
    }
    get iconDefinitions() {
        return this._iconDefinitions;
    }
    set placeholderDefinitions(placeholderDefinitions) {
        if (isNull(placeholderDefinitions))
            return;
        this._placeholderNodeDefinition = placeholderDefinitions;
        if (!this._loading) {
            this.initializeTreeData();
        }
    }
    get placeholderDefinitions() {
        return this._placeholderNodeDefinition;
    }
    set searchPlaceholder(placeholder) {
        this._searchPlaceholder = placeholder;
    }
    get searchPlaceholder() {
        return this._searchPlaceholder;
    }
    get totalSearchResults() {
        return this._searchFoundNodes.size;
    }
    get totalSelectableSearchResults() {
        return [...this._searchFoundNodes].filter(node => !node.disabled).length;
    }
    get totalSelectedNodes() {
        return this._selectedNodes.size;
    }
    set selectedNodes(selectedNodes) {
        if (isNull(selectedNodes))
            return;
        // if we are loading, there may be a race condition with the angular life cycle loading treeData
        if (this._loading) {
            this._selectedNodes.clear();
            [...selectedNodes].forEach(node => this._selectedNodes.add(node));
        }
        else {
            this.deselectAllNodes();
            this.selectNodes([...selectedNodes]);
        }
    }
    set select(selectedNodeId) {
        if (isNull(selectedNodeId))
            return;
        if (!this._loading) {
            const node = this.getNodeById(selectedNodeId);
            if (node) {
                if (!node.disabled && !node.selected) {
                    this.selectNode(node);
                    this.expandTo(node);
                }
            }
        }
    }
    set deselect(deselectedNodeId) {
        if (isNull(deselectedNodeId))
            return;
        if (!this._loading) {
            const node = this.getNodeById(deselectedNodeId);
            if (node) {
                if (!node.disabled && node.selected) {
                    this.deselectNode(node);
                }
            }
        }
    }
    set expandedNodes(expandedNodes) {
        if (isNull(expandedNodes))
            return;
        // if we are loading, there may be a race condition with the angular life cycle loading treeData
        if (this._loading) {
            this._expandedNodes.clear();
            [...expandedNodes].forEach(node => this._expandedNodes.add(node));
        }
        else {
            this.collapseAllNodes();
            this.expandTo([...expandedNodes], true);
        }
    }
    set disabledNodeDefinitions(disabledNodeDefs) {
        if (isNull(disabledNodeDefs))
            return;
        this._disabledNodeDefinitions = disabledNodeDefs;
        if (!this._loading) {
            this.initializeTreeData();
        }
    }
    set cascadeSelect(cascadeSelect) {
        if (isNull(cascadeSelect))
            return;
        this._multiSelect ? (this._cascadeSelect = cascadeSelect) : (this._cascadeSelect = false);
    }
    get cascadeSelect() {
        return this._cascadeSelect;
    }
    set expandAll(expandAll) {
        this._expandAll = expandAll;
        expandAll ? this.expandAllNodes() : this.collapseAllNodes();
    }
    set showSearch(showSearch) {
        if (isNull(showSearch))
            return;
        this._showSearch = showSearch;
    }
    get showSearch() {
        return this._showSearch;
    }
    set showControls(showControls) {
        if (isNull(showControls))
            return;
        this._showControls = showControls;
    }
    get showControls() {
        return this._showControls;
    }
    set allowSelectAllResults(allowSelectAllResults) {
        if (isNull(allowSelectAllResults))
            return;
        this._allowSelectAllResults = allowSelectAllResults;
    }
    get allowSelectAllResults() {
        return this._allowSelectAllResults;
    }
    set allowDeselectAll(allowDeselectAll) {
        if (isNull(allowDeselectAll))
            return;
        this._allowDeselectAll = allowDeselectAll;
    }
    get allowDeselectAll() {
        return this._allowDeselectAll;
    }
    set hideIrrelevant(hide) {
        this._hideIrrelevant = hide;
    }
    get hideIrrelevant() {
        return this._hideIrrelevant;
    }
    set hideDisabledCheckbox(hide) {
        this._hideDisabledCheckbox = hide;
    }
    get hideDisabledCheckbox() {
        return this._hideDisabledCheckbox;
    }
    set searchProperties(searchProps) {
        if (isNull(searchProps))
            return;
        this._searchProperties = searchProps;
    }
    set searchString(query) {
        if (isNull(query))
            return;
        this._searchString = query;
        this.search(query.toLowerCase());
    }
    get searchString() {
        return this._searchString;
    }
    get originalNodes() {
        return this._originalNodes;
    }
    ngOnInit() {
        this.initializeTreeData();
        this._loading = false;
    }
    /**
     * Initialize every node in memory in the Set on the enel-tree with appropriate attributes.
     */
    initializeTreeData() {
        // step 1.
        this.flattenTree(this._originalNodes);
        // step 2.
        this.initializeSelections();
        this.initializeExpanded();
        // step 3.
        for (const node of this._flattenedTree) {
            this.updateTreeNodeAttributes(node);
        }
        // step 4.
        this.createVirtualTree(this._originalNodes);
        // Persist search after tree data is updated
        if (this._searching) {
            const expandedBeforeSearch = this._flattenedTree.filter(node => node.expanded);
            this.search(this._searchString.toLowerCase());
            expandedBeforeSearch.forEach(node => {
                this.expandNode(node);
            });
        }
    }
    initializeSelections() {
        for (const selectingNode of this._selectedNodes) {
            if (selectingNode?.id) {
                // the current selectedNode is passed in before it was copied to the enel-tree, thus a different object reference
                this._selectedNodes.delete(selectingNode);
                if (this._mappedTree[selectingNode.id] != null) {
                    this._mappedTree[selectingNode.id].selected = true;
                }
            }
        }
    }
    initializeExpanded() {
        for (const expandingNode of this._expandedNodes) {
            if (expandingNode?.id) {
                // the current expandingNode is passed in before it was copied to the enel-tree, thus a different object reference
                this._expandedNodes.delete(expandingNode);
                if (this._mappedTree[expandingNode.id] != null) {
                    this._mappedTree[expandingNode.id].expanded = true;
                }
            }
        }
    }
    calculateHeight() {
        const itemHeight = 28;
        return this.virtualTreeDisplay().length * itemHeight;
    }
    isNodeSelectable(node) {
        return !node.disabled && !this.isTreeAtMaxSelection();
    }
    isNodeDisabled(node) {
        if (isNull(this._disabledNodeDefinitions)) {
            return false;
        }
        // Check if node has properties that match in _disabledNodeDefinitions
        let isDisabled = false;
        Object.keys(this._disabledNodeDefinitions).forEach((key) => {
            if (this._disabledNodeDefinitions && this._disabledNodeDefinitions[key]?.includes(node[key])) {
                isDisabled = true;
                return;
            }
            if (!node.selected && this.isTreeAtMaxSelection()) {
                isDisabled = true;
                return;
            }
        });
        return isDisabled;
    }
    isPlaceholder(node) {
        if (isNull(this._placeholderNodeDefinition)) {
            return false;
        }
        // Check if node has properties that match in _placeholderDefinition
        let placeholder = false;
        Object.keys(this._placeholderNodeDefinition).forEach((key) => {
            if (this._placeholderNodeDefinition && this._placeholderNodeDefinition[key]?.includes(node[key])) {
                placeholder = true;
                return;
            }
        });
        return placeholder;
    }
    isTreeAtMaxSelection() {
        let atMaxSelection = false;
        if (this._multiSelect && this._maxSelections > 0) {
            if (this._selectedNodes.size >= this._maxSelections) {
                atMaxSelection = true;
            }
        }
        return atMaxSelection;
    }
    showCollapseAll() {
        // show collapse all button all the time.
        // we may want to do logic here, for now this is to ensure the controls has a height all the time
        return true;
    }
    showSelectAllResults() {
        return this._searchFoundNodes.size > 0 && this._allowSelectAllResults && this._searchString.length >= 3;
    }
    showDeselectAll() {
        return this._allowDeselectAll && this._selectedNodes.size > 1;
    }
    getIcon(node) {
        return this._iconDefinitions[node[this._iconIdentifier]];
    }
    getNodeById(nodeId) {
        return this._mappedTree[nodeId];
    }
    virtualTreeDisplay() {
        return this._virtualTree.filter(node => node.shown === true);
    }
    toggleNode(node) {
        if (node.expanded) {
            this.collapseNodeCascade(this._mappedTree[node.id]);
        }
        else {
            this.expandNode(this._mappedTree[node.id]);
        }
    }
    clickedNode(node) {
        this.clicked$.emit(node);
    }
    expandTo(nodes, expandSelf) {
        if (!Array.isArray(nodes))
            nodes = [nodes];
        if (isNull(nodes) || !nodes.length)
            return;
        nodes.forEach((node) => {
            if (Array.isArray(node?.parent) && node.parent.length > 0) {
                node.parent.forEach((parentNodeId) => {
                    this.expandNode(this._mappedTree[parentNodeId]);
                });
            }
            if (expandSelf) {
                this.expandNode(this._mappedTree[node.id]);
            }
        });
    }
    expandNode(node, skipEvent = false) {
        if (!node.children || node.children.length === 0)
            return;
        node.expanded = true;
        node.shown = true;
        // If hide irrelevant only show nodes matching search
        if (this._hideIrrelevant && this._searching) {
            const matchingNodes = node.children.filter((child) => Array.from(this._nodesToDisplay).includes(child));
            matchingNodes.forEach((child) => {
                child.shown = true;
            });
        }
        else {
            node.children.forEach((child) => {
                child.shown = true;
            });
        }
        this._expandedNodes.add(node);
        if (!skipEvent) {
            this.expansion$.emit([...this._expandedNodes]);
        }
    }
    /**
     * Takes in one or more nodes to display, and will
     * generate a tree containing the minimum amount
     * of nodes needed to display all wanted nodes
     *
     * @private - just an internal helper
     * @param nodes the nodes which to display
     */
    displayMinimumHierarchy(nodes) {
        this.collapseAllNodes();
        this._flattenedTree.forEach(node => node.shown = false);
        const nodesToDisplay = [];
        if (!Array.isArray(nodes))
            nodes = [nodes];
        if (isNull(nodes) || !nodes.length)
            return;
        nodes.forEach((node) => {
            nodesToDisplay.push(node);
            // Expand parents of matched nodes
            if (Array.isArray(node?.parent) && node.parent.length > 0) {
                node.parent.forEach((parentNodeId) => {
                    const nodeToExpand = this._mappedTree[parentNodeId];
                    // Show all children if parent node being expanded is a node that is matched as well
                    if (nodes.includes(nodeToExpand)) {
                        nodeToExpand.children?.forEach(childNode => {
                            childNode.shown = true;
                        });
                    }
                    nodeToExpand.expanded = true;
                    nodeToExpand.shown = true;
                    this._expandedNodes.add(nodeToExpand);
                    nodesToDisplay.push(nodeToExpand);
                });
                this.expansion$.emit([...this._expandedNodes]);
            }
            // Allow children of matched nodes to be shown
            if (Array.isArray(node?.children) && node.children.length > 0) {
                node.children.forEach((childNode) => {
                    nodesToDisplay.push(...this.getFlatSubtree(childNode));
                });
            }
            node.shown = true;
        });
        this._nodesToDisplay = new Set(nodesToDisplay);
    }
    selectNode(node) {
        if (this._multiSelect && this._cascadeSelect) {
            this.selectNodeCascade(node);
        }
        else {
            if (!this._multiSelect) {
                this.deselectAllNodes();
            }
            this.selectNodes([node]);
        }
    }
    areChildren() {
        return this._virtualTree.some(node => node.children?.length);
    }
    selectSearchedNodes() {
        this.selectNodes([...this._searchFoundNodes]);
    }
    deselectAllNodes(skipEvent = false) {
        this.deselectNodes([...this._selectedNodes]);
    }
    deselectNode(node) {
        if (this._forceSelection && this._selectedNodes.size == 1) {
            return;
        }
        if (this._multiSelect && this._cascadeSelect) {
            this.deselectNodeCascade(this._mappedTree[node.id]);
        }
        else {
            this.deselectNodes([this._mappedTree[node.id]]);
        }
    }
    deselectNodes(nodes) {
        for (const deselectedNode of nodes) {
            deselectedNode.selected = false;
            if (this._selectedNodes.has(this._mappedTree[deselectedNode.id])) {
                // Only deselect the passed in Nodes
                this._selectedNodes.delete(deselectedNode);
            }
        }
        if (!this.isTreeAtMaxSelection()) {
            this.enableRemainingNodes();
        }
        this.deselection$.emit([...this._selectedNodes]);
    }
    deselectNodeCascade(node) {
        const nodesToDeselect = this._flattenedTree.reduce((nodesDescendents, currentNode) => {
            // cascade - if the node is a parent, then deselect the children
            if (currentNode.parent?.find(parent => parent === node.id)) {
                nodesDescendents.push(currentNode);
            }
            return nodesDescendents;
        }, [node]);
        this.deselectNodes(nodesToDeselect);
    }
    collapseAllNodes() {
        // set expanded property on all nodes add all to expanded array
        for (const expandedNode of this._expandedNodes) {
            this.collapseNode(expandedNode, true);
        }
        this.expansion$.emit([...this._expandedNodes]);
    }
    collapseNode(node, skipEvent = false) {
        node.expanded = false;
        node.children?.forEach((child) => {
            child.shown = false;
        });
        this._expandedNodes.delete(node);
        if (!skipEvent) {
            this.expansion$.emit([...this._expandedNodes]);
        }
    }
    collapseNodeCascade(node) {
        this._flattenedTree.forEach(currentNode => {
            // cascade - if the node is a parent, then deselect the children
            if (currentNode.parent?.find(parent => parent === node.id)) {
                this.collapseNode(currentNode, true);
            }
        });
        this.collapseNode(node, true);
        this.expansion$.emit([...this._expandedNodes]);
    }
    clearSearch() {
        this.searchString = '';
    }
    search(filter) {
        debounceTime(200);
        this._searchFoundNodes.clear();
        const matchedNodes = [];
        if (filter.length < 1) {
            this._searching = false;
            this._flattenedTree.forEach(node => node.highlighted = false);
        }
        else {
            this._searching = true;
            this._flattenedTree.filter(node => !node.placeholder).forEach(node => {
                this._searchProperties.forEach((property) => {
                    if (node[property].toLowerCase().includes(filter)) {
                        node.highlighted = true;
                        this._searchFoundNodes.add(node);
                        if (!this._hideIrrelevant) {
                            this.expandTo(node);
                        }
                        else {
                            matchedNodes.push(node);
                        }
                    }
                    else {
                        node.highlighted = false;
                    }
                });
            });
        }
        // If hide irrelevant flag is set
        if (this._hideIrrelevant) {
            // If there is a valid search
            if (this._searching) {
                this.displayMinimumHierarchy(matchedNodes);
            }
            else {
                // Clean node states
                this._flattenedTree.forEach(node => {
                    node.shown = true;
                    this._expandedNodes.add(node);
                });
                this.collapseAllNodes();
            }
        }
    }
    updateTreeNodeAttributes(node) {
        if (node) {
            if (node.selected) {
                this.selectNode(node);
            }
            if (node.expanded) {
                this.expandTo(node, true);
            }
            if (node[this._iconIdentifier]) {
                node.icon = this._iconDefinitions[node[this._iconIdentifier]];
            }
            node.placeholder = this.isPlaceholder(node);
            node.disabled = this.isNodeDisabled(node);
        }
    }
    /**
     * Take all nodes from all levels out of the tree and
     * create a single dimensional array from them.
     *
     * @param tree - TreeNode[] with a children property for each sub-level
     * @private - just an internal helper
     */
    flattenTree(tree) {
        // reset the internal structures
        this._flattenedTree = [];
        this._mappedTree = {};
        // terminal condition tracker
        const unflattenedNodes = [...tree];
        // temporary current node
        let node;
        // iterate until all nodes have been looked at
        while (unflattenedNodes.length > 0) {
            node = unflattenedNodes.pop();
            if (node === undefined)
                continue;
            this._flattenedTree.push(node);
            this._mappedTree[node.id] = node;
            if (node.children) {
                node.children.forEach((child) => {
                    // @ts-ignore
                    child.parent = node.parent ? [...node.parent, node.id] : [node.id];
                    unflattenedNodes.push(child);
                });
            }
        }
    }
    createVirtualTree(tree) {
        this._virtualTree = [];
        for (const node of tree) {
            if (node) {
                node.shown = true;
                this.virtualTreeHelper(node);
            }
        }
    }
    virtualTreeHelper(node) {
        const nodeChildren = [node];
        let currentNode;
        while (nodeChildren.length > 0) {
            currentNode = nodeChildren.shift();
            if (!currentNode)
                continue;
            this._virtualTree.push(currentNode);
            if (!currentNode.children)
                continue;
            currentNode.children?.reverse().forEach(child => nodeChildren.unshift(child));
        }
    }
    expandAllNodes() {
        // set expanded property on all nodes add all to expanded array
        for (const node of this._virtualTree) {
            this.expandNode(node, true);
        }
        this.expansion$.emit([...this._expandedNodes]);
    }
    disableRemainingNodes() {
        if (!this.isTreeAtMaxSelection()) {
            return;
        }
        this._flattenedTree.forEach(node => {
            if (node.selected) {
                return;
            }
            else {
                node.disabled = true;
            }
        });
    }
    enableRemainingNodes() {
        this._flattenedTree.forEach(node => {
            if (this.isNodeDisabled(node)) {
                return;
            }
            else {
                node.disabled = false;
            }
        });
    }
    selectNodes(nodes) {
        for (const node of nodes) {
            if (this.isNodeSelectable(node) && !this.isTreeAtMaxSelection()) {
                if (!node.shown) {
                    this.expandTo(node, false);
                }
                node.selected = true;
                // _selectedNodes is a set, so we can blindly add elements
                this._selectedNodes.add(node);
                if (this.isTreeAtMaxSelection()) {
                    this.disableRemainingNodes();
                    break;
                }
            }
        }
        this.selection$.emit([...this._selectedNodes]);
    }
    selectNodeCascade(node) {
        this.selectNodes([node]);
        if (!node.children)
            return;
        const nodeChildren = [...node.children];
        let currentNode;
        while (nodeChildren.length > 0 && !this.isTreeAtMaxSelection()) {
            currentNode = nodeChildren.pop();
            if (!currentNode)
                continue;
            this.selectNodeCascade(currentNode);
            if (this.isTreeAtMaxSelection()) {
                this.disableRemainingNodes();
            }
        }
    }
    getFlatSubtree(root) {
        if (!root.children)
            return [root];
        const nodeChildren = [...root.children];
        let childTrees = [];
        nodeChildren.forEach(child => {
            childTrees.push(...this.getFlatSubtree(child));
        });
        return [root, ...childTrees];
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TreeComponent, deps: [{ token: i1$1.MatIconRegistry }, { token: i2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: TreeComponent, selector: "enel-tree-display", inputs: { treeData: "treeData", multiSelect: "multiSelect", forceSelection: "forceSelection", checkbox: "checkbox", expandable: "expandable", maxSelections: "maxSelections", labelIdentifier: "labelIdentifier", typeIdentifier: "typeIdentifier", iconIdentifier: "iconIdentifier", iconDefinitions: "iconDefinitions", placeholderDefinitions: "placeholderDefinitions", searchPlaceholder: "searchPlaceholder", selectedNodes: "selectedNodes", select: "select", deselect: "deselect", expandedNodes: "expandedNodes", disabledNodeDefinitions: "disabledNodeDefinitions", cascadeSelect: "cascadeSelect", expandAll: "expandAll", showSearch: "showSearch", showControls: "showControls", allowSelectAllResults: "allowSelectAllResults", allowDeselectAll: "allowDeselectAll", hideIrrelevant: "hideIrrelevant", hideDisabledCheckbox: "hideDisabledCheckbox", searchProperties: "searchProperties", searchString: "searchString" }, outputs: { selection$: "selection$", deselection$: "deselection$", expansion$: "expansion$", clicked$: "clicked$" }, queries: [{ propertyName: "nodeTemplateRef", first: true, predicate: ["nodeTemplate"], descendants: true }], ngImport: i0, template: "<div class=\"w-auto\" [ngClass]=\"originalNodes.length ? 'enel-tree-display' : 'enel-tree-display-invisible'\">\r\n  <div [hidden]=\"!showSearch\" class='flex items-center search-container'>\r\n    <input\r\n      matInput\r\n      id=\"enel-tree-search-input\"\r\n      type=\"search\"\r\n      #enelTreeSearchInput=\"ngModel\"\r\n      ngClass=\"search-input enel-search\"\r\n      placeholder=\"{{ searchPlaceholder }}\"\r\n      name=\"enelTreeSearchInput\"\r\n      [(ngModel)]=\"searchString\"\r\n      required\r\n      maxlength=\"80\"\r\n    >\r\n  </div>\r\n\r\n  <div [hidden]=\"!showControls\" class='controls-container'>\r\n    <div class=\"controls\">\r\n      <div class=\"tree-control\" data-automation=\"tree-controls-collapse-all\"\r\n           [hidden]=\"!areChildren()\"\r\n           *ngIf=\"showCollapseAll()\"\r\n           (click)=\"collapseAllNodes()\">\r\n        <mat-icon svgIcon=\"collapse_all\"></mat-icon>\r\n        <span>{{ 'enel-tree.collapse_all' | translate }}</span>\r\n      </div>\r\n      <div class=\"tree-control\" data-automation=\"tree-controls-select-all\"\r\n           *ngIf=\"showSelectAllResults()\"\r\n           (click)=\"selectSearchedNodes()\">\r\n        <mat-icon svgIcon=\"select_all\"></mat-icon>\r\n        <span>{{ 'enel-tree.select_all' | translate }} ({{totalSelectableSearchResults}})</span>\r\n      </div>\r\n      <div class=\"tree-control\" data-automation=\"tree-controls-deselect-all\"\r\n           *ngIf=\"showDeselectAll()\"\r\n           (click)=\"deselectAllNodes()\">\r\n        <mat-icon svgIcon=\"deselect_all\"></mat-icon>\r\n        <span>{{ 'enel-tree.deselect_all' | translate }} ({{totalSelectedNodes}})</span>\r\n      </div>\r\n    </div>\r\n    <span class=\"enel-tree-number-of-results\"\r\n          *ngIf=\"totalSearchResults > 0\">\r\n      ({{totalSearchResults}} {{ 'enel-tree.results' | translate }})\r\n  </span>\r\n  </div>\r\n\r\n  <cdk-virtual-scroll-viewport class=\"virtual-viewport\" [itemSize]=\"24\">\r\n    <tree-node *cdkVirtualFor=\"let node of virtualTreeDisplay()\"\r\n               [ngClass]=\"'flex justify-start'\"\r\n               [model]=\"node\"\r\n               [multiSelect]=\"multiSelect\"\r\n               [forceSelection]=\"forceSelection\"\r\n               [expandable]=\"expandable\"\r\n               [checkbox]=\"checkbox\"\r\n               [typeIdentifier]=\"typeIdentifier\"\r\n               [labelIdentifier]=\"labelIdentifier\"\r\n               [iconIdentifier]=\"iconIdentifier\"\r\n               (selection$)=\"selectNode($event)\"\r\n               (deselection$)=\"deselectNode($event)\"\r\n               (expansion$)=\"toggleNode($event)\"\r\n               (clicked$)=\"clickedNode($event)\"\r\n               [childTemplate]=\"nodeTemplateRef\"\r\n               [hideDisabledCheckbox]=\"hideDisabledCheckbox\"\r\n      ></tree-node>\r\n    </cdk-virtual-scroll-viewport>\r\n</div>\r\n", styles: [".mat-tree{background-color:transparent}.tree-control{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:end;-webkit-align-items:end;-ms-flex-align:end;align-items:end;cursor:pointer;overflow:hidden}.tree-control span{font-style:italic;padding-right:.25em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.tree-control mat-icon{-webkit-box-flex:0;-webkit-flex:none;-ms-flex:none;flex:none;-webkit-transform:scale(.8);-ms-transform:scale(.8);transform:scale(.8)}.tree-item{cursor:pointer;display:inline-block}.enel-tree-display-invisible{display:none}.enel-tree-display{padding-left:10px;font-size:13px;height:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.virtual-viewport{height:100%;left:-1.5em}cdk-virtual-scroll-viewport::-webkit-scrollbar{width:8px}cdk-virtual-scroll-viewport::-webkit-scrollbar-track{background:var(--sidebar-bg-color)}cdk-virtual-scroll-viewport::-webkit-scrollbar-thumb{background:var(--primary-lighter-color);border-radius:6px}cdk-virtual-scroll-viewport::-webkit-scrollbar-thumb:hover{background:var(--primary-color)}.enel-tree-button{margin:2px 0;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#fafbfc;border:1px solid #B8B8B8;border-radius:15px;box-shadow:rgba(27,31,35,.04) 0 1px,rgba(255,255,255,.25) 0 1px inset;box-sizing:border-box;cursor:pointer;display:inline-block;font-size:12px;font-weight:600;line-height:20px;list-style:none;padding:3px 16px;position:relative;-webkit-transition:background-color .2s cubic-bezier(.3,0,.5,1);transition:background-color .2s cubic-bezier(.3,0,.5,1);-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-user-select:none;-ms-touch-action:manipulation;touch-action:manipulation;vertical-align:middle;white-space:nowrap;word-wrap:break-word}.enel-tree-button:hover{background-color:#c8bcd8;text-decoration:none;-webkit-transition-duration:.1s;transition-duration:.1s}.enel-tree-button:disabled{background-color:#fafbfc;border-color:rgba(27,31,35,.15);color:#959da5;cursor:default}.enel-tree-button:active{background-color:#c8bcd8;box-shadow:rgba(225,228,232,.2) 0 1px inset;-webkit-transition:none 0s;transition:none 0s}.enel-tree-button:focus{outline:1px transparent}.enel-tree-button:before{display:none}.enel-tree-button::-webkit-details-marker{display:none}.enel-tree ul li{margin-top:0;margin-bottom:0;list-style-type:none;font-family:Roobert,Helvetica,Arial,sans-serif}.search-container{padding-right:2em}.controls-container{padding:10px 2em 10px 0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.controls{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;gap:5px;-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;overflow:hidden}.enel-tree-number-of-results{white-space:nowrap;-webkit-align-self:end;-ms-flex-item-align:end;align-self:end;float:right;padding-top:10px;font-size:.75em}.mat-mdc-checkbox-disabled ::ng-deep span.mat-mdc-checkbox-label mat-icon{color:rgba(0,0,0,.34)}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i4.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i4.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i1$1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i5.CdkFixedSizeVirtualScroll, selector: "cdk-virtual-scroll-viewport[itemSize]", inputs: ["itemSize", "minBufferPx", "maxBufferPx"] }, { kind: "directive", type: i5.CdkVirtualForOf, selector: "[cdkVirtualFor][cdkVirtualForOf]", inputs: ["cdkVirtualForOf", "cdkVirtualForTrackBy", "cdkVirtualForTemplate", "cdkVirtualForTemplateCacheSize"] }, { kind: "component", type: i5.CdkVirtualScrollViewport, selector: "cdk-virtual-scroll-viewport", inputs: ["orientation", "appendOnly"], outputs: ["scrolledIndexChange"] }, { kind: "directive", type: i6.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: TreeNodeComponent, selector: "tree-node", inputs: ["model", "multiSelect", "forceSelection", "hideDisabledCheckbox", "checkbox", "expandable", "labelIdentifier", "typeIdentifier", "iconIdentifier", "childTemplate"], outputs: ["selection$", "deselection$", "clicked$", "expansion$"] }, { kind: "pipe", type: i8.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TreeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'enel-tree-display', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"w-auto\" [ngClass]=\"originalNodes.length ? 'enel-tree-display' : 'enel-tree-display-invisible'\">\r\n  <div [hidden]=\"!showSearch\" class='flex items-center search-container'>\r\n    <input\r\n      matInput\r\n      id=\"enel-tree-search-input\"\r\n      type=\"search\"\r\n      #enelTreeSearchInput=\"ngModel\"\r\n      ngClass=\"search-input enel-search\"\r\n      placeholder=\"{{ searchPlaceholder }}\"\r\n      name=\"enelTreeSearchInput\"\r\n      [(ngModel)]=\"searchString\"\r\n      required\r\n      maxlength=\"80\"\r\n    >\r\n  </div>\r\n\r\n  <div [hidden]=\"!showControls\" class='controls-container'>\r\n    <div class=\"controls\">\r\n      <div class=\"tree-control\" data-automation=\"tree-controls-collapse-all\"\r\n           [hidden]=\"!areChildren()\"\r\n           *ngIf=\"showCollapseAll()\"\r\n           (click)=\"collapseAllNodes()\">\r\n        <mat-icon svgIcon=\"collapse_all\"></mat-icon>\r\n        <span>{{ 'enel-tree.collapse_all' | translate }}</span>\r\n      </div>\r\n      <div class=\"tree-control\" data-automation=\"tree-controls-select-all\"\r\n           *ngIf=\"showSelectAllResults()\"\r\n           (click)=\"selectSearchedNodes()\">\r\n        <mat-icon svgIcon=\"select_all\"></mat-icon>\r\n        <span>{{ 'enel-tree.select_all' | translate }} ({{totalSelectableSearchResults}})</span>\r\n      </div>\r\n      <div class=\"tree-control\" data-automation=\"tree-controls-deselect-all\"\r\n           *ngIf=\"showDeselectAll()\"\r\n           (click)=\"deselectAllNodes()\">\r\n        <mat-icon svgIcon=\"deselect_all\"></mat-icon>\r\n        <span>{{ 'enel-tree.deselect_all' | translate }} ({{totalSelectedNodes}})</span>\r\n      </div>\r\n    </div>\r\n    <span class=\"enel-tree-number-of-results\"\r\n          *ngIf=\"totalSearchResults > 0\">\r\n      ({{totalSearchResults}} {{ 'enel-tree.results' | translate }})\r\n  </span>\r\n  </div>\r\n\r\n  <cdk-virtual-scroll-viewport class=\"virtual-viewport\" [itemSize]=\"24\">\r\n    <tree-node *cdkVirtualFor=\"let node of virtualTreeDisplay()\"\r\n               [ngClass]=\"'flex justify-start'\"\r\n               [model]=\"node\"\r\n               [multiSelect]=\"multiSelect\"\r\n               [forceSelection]=\"forceSelection\"\r\n               [expandable]=\"expandable\"\r\n               [checkbox]=\"checkbox\"\r\n               [typeIdentifier]=\"typeIdentifier\"\r\n               [labelIdentifier]=\"labelIdentifier\"\r\n               [iconIdentifier]=\"iconIdentifier\"\r\n               (selection$)=\"selectNode($event)\"\r\n               (deselection$)=\"deselectNode($event)\"\r\n               (expansion$)=\"toggleNode($event)\"\r\n               (clicked$)=\"clickedNode($event)\"\r\n               [childTemplate]=\"nodeTemplateRef\"\r\n               [hideDisabledCheckbox]=\"hideDisabledCheckbox\"\r\n      ></tree-node>\r\n    </cdk-virtual-scroll-viewport>\r\n</div>\r\n", styles: [".mat-tree{background-color:transparent}.tree-control{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:end;-webkit-align-items:end;-ms-flex-align:end;align-items:end;cursor:pointer;overflow:hidden}.tree-control span{font-style:italic;padding-right:.25em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.tree-control mat-icon{-webkit-box-flex:0;-webkit-flex:none;-ms-flex:none;flex:none;-webkit-transform:scale(.8);-ms-transform:scale(.8);transform:scale(.8)}.tree-item{cursor:pointer;display:inline-block}.enel-tree-display-invisible{display:none}.enel-tree-display{padding-left:10px;font-size:13px;height:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.virtual-viewport{height:100%;left:-1.5em}cdk-virtual-scroll-viewport::-webkit-scrollbar{width:8px}cdk-virtual-scroll-viewport::-webkit-scrollbar-track{background:var(--sidebar-bg-color)}cdk-virtual-scroll-viewport::-webkit-scrollbar-thumb{background:var(--primary-lighter-color);border-radius:6px}cdk-virtual-scroll-viewport::-webkit-scrollbar-thumb:hover{background:var(--primary-color)}.enel-tree-button{margin:2px 0;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#fafbfc;border:1px solid #B8B8B8;border-radius:15px;box-shadow:rgba(27,31,35,.04) 0 1px,rgba(255,255,255,.25) 0 1px inset;box-sizing:border-box;cursor:pointer;display:inline-block;font-size:12px;font-weight:600;line-height:20px;list-style:none;padding:3px 16px;position:relative;-webkit-transition:background-color .2s cubic-bezier(.3,0,.5,1);transition:background-color .2s cubic-bezier(.3,0,.5,1);-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-user-select:none;-ms-touch-action:manipulation;touch-action:manipulation;vertical-align:middle;white-space:nowrap;word-wrap:break-word}.enel-tree-button:hover{background-color:#c8bcd8;text-decoration:none;-webkit-transition-duration:.1s;transition-duration:.1s}.enel-tree-button:disabled{background-color:#fafbfc;border-color:rgba(27,31,35,.15);color:#959da5;cursor:default}.enel-tree-button:active{background-color:#c8bcd8;box-shadow:rgba(225,228,232,.2) 0 1px inset;-webkit-transition:none 0s;transition:none 0s}.enel-tree-button:focus{outline:1px transparent}.enel-tree-button:before{display:none}.enel-tree-button::-webkit-details-marker{display:none}.enel-tree ul li{margin-top:0;margin-bottom:0;list-style-type:none;font-family:Roobert,Helvetica,Arial,sans-serif}.search-container{padding-right:2em}.controls-container{padding:10px 2em 10px 0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.controls{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;gap:5px;-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;overflow:hidden}.enel-tree-number-of-results{white-space:nowrap;-webkit-align-self:end;-ms-flex-item-align:end;align-self:end;float:right;padding-top:10px;font-size:.75em}.mat-mdc-checkbox-disabled ::ng-deep span.mat-mdc-checkbox-label mat-icon{color:rgba(0,0,0,.34)}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.MatIconRegistry }, { type: i2.DomSanitizer }]; }, propDecorators: { treeData: [{
                type: Input
            }], multiSelect: [{
                type: Input
            }], forceSelection: [{
                type: Input
            }], checkbox: [{
                type: Input
            }], expandable: [{
                type: Input
            }], maxSelections: [{
                type: Input
            }], labelIdentifier: [{
                type: Input
            }], typeIdentifier: [{
                type: Input
            }], iconIdentifier: [{
                type: Input
            }], iconDefinitions: [{
                type: Input
            }], placeholderDefinitions: [{
                type: Input
            }], searchPlaceholder: [{
                type: Input
            }], selectedNodes: [{
                type: Input
            }], select: [{
                type: Input
            }], deselect: [{
                type: Input
            }], expandedNodes: [{
                type: Input
            }], disabledNodeDefinitions: [{
                type: Input
            }], cascadeSelect: [{
                type: Input
            }], expandAll: [{
                type: Input
            }], showSearch: [{
                type: Input
            }], showControls: [{
                type: Input
            }], allowSelectAllResults: [{
                type: Input
            }], allowDeselectAll: [{
                type: Input
            }], hideIrrelevant: [{
                type: Input
            }], hideDisabledCheckbox: [{
                type: Input
            }], searchProperties: [{
                type: Input
            }], searchString: [{
                type: Input
            }], selection$: [{
                type: Output
            }], deselection$: [{
                type: Output
            }], expansion$: [{
                type: Output
            }], clicked$: [{
                type: Output
            }], nodeTemplateRef: [{
                type: ContentChild,
                args: ['nodeTemplate', { static: false }]
            }] } });

class FilterPipe {
    transform(value, searchText) {
        if (searchText) {
            searchText = searchText.toLowerCase();
            return value.filter(function (el) {
                return el.display_label.toLowerCase().indexOf(searchText) > -1;
            });
        }
        return value;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FilterPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FilterPipe, name: "filter" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FilterPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'filter'
                }]
        }] });

class VarDirective {
    set ngVar(context) {
        this.context.$implicit = this.context.ngVar = context;
        this.updateView();
    }
    constructor(vcRef, templateRef) {
        this.vcRef = vcRef;
        this.templateRef = templateRef;
        this.context = {};
    }
    updateView() {
        this.vcRef.clear();
        this.vcRef.createEmbeddedView(this.templateRef, this.context);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: VarDirective, deps: [{ token: i0.ViewContainerRef }, { token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: VarDirective, selector: "[ngVar]", inputs: { ngVar: "ngVar" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: VarDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ngVar]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }, { type: i0.TemplateRef }]; }, propDecorators: { ngVar: [{
                type: Input
            }] } });

class TreeNode {
    constructor() {
        this.id = '';
        this.displayLabel = '';
        this.nodeType = 'default';
        this.children = [];
        this.parent = [];
        this.expanded = false;
        this.highlighted = false;
        this.disabled = false;
        this.shown = true;
        this.selected = false;
        this.icon = undefined;
        this.placeholder = false;
    }
}

function createTranslateLoader(http) {
    return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}
class TreeModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TreeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: TreeModule, declarations: [TreeComponent, TreeNodeComponent, FilterPipe, VarDirective], imports: [CommonModule,
            FormsModule,
            HttpClientModule,
            BrowserAnimationsModule, i8.TranslateModule, MatIconModule,
            MatCheckboxModule,
            ScrollingModule,
            MatInputModule,
            MatTooltipModule], exports: [TreeComponent, TreeNodeComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TreeModule, providers: [
            TranslateService, HttpClient
            //  { provide: NAMESPACE_TOKEN, useValue: '' },
        ], imports: [CommonModule,
            FormsModule,
            HttpClientModule,
            BrowserAnimationsModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: (createTranslateLoader),
                    deps: [HttpClient]
                }
            }),
            MatIconModule,
            MatCheckboxModule,
            ScrollingModule,
            MatInputModule,
            MatTooltipModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TreeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        HttpClientModule,
                        BrowserAnimationsModule,
                        TranslateModule.forRoot({
                            loader: {
                                provide: TranslateLoader,
                                useFactory: (createTranslateLoader),
                                deps: [HttpClient]
                            }
                        }),
                        MatIconModule,
                        MatCheckboxModule,
                        ScrollingModule,
                        MatInputModule,
                        MatTooltipModule,
                    ],
                    declarations: [TreeComponent, TreeNodeComponent, FilterPipe, VarDirective],
                    exports: [TreeComponent, TreeNodeComponent],
                    providers: [
                        TranslateService, HttpClient
                        //  { provide: NAMESPACE_TOKEN, useValue: '' },
                    ],
                    // schemas: [CUSTOM_ELEMENTS_SCHEMA]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TreeComponent, TreeModule, TreeNode, TreeNodeComponent, createTranslateLoader };
